import { takeEvery } from 'redux-saga/effects'
// @ts-ignore
import { store } from 'store'
// @ts-ignore
import { showError } from 'store/entities/toastr/utils'
import { deleteImageFromGallery } from 'store/entities/gallery/actions'
import { change, formValueSelector, getFormNames } from 'redux-form/immutable'
import { IResetImageInputs } from './interfaces'

export default function* resetImageInputs() {
  yield takeEvery(deleteImageFromGallery.success as any, handleResetImageInputs)
}
// TODO: @rastym write tests for this saga
export function* handleResetImageInputs({ meta }: IResetImageInputs) {
  try {
    const state = store.getState()
    const removedImageUrl = meta.request.data.url
    const forms = getFormNames()(state)
    forms.forEach(formName => {
      const imageInpValue = formValueSelector(formName)(state, 'image')
      // If image was was deleted, clear all image inputs which is using this image
      if (imageInpValue === removedImageUrl) {
        store.dispatch(change(formName, 'image', ''))
      }
    })
  } catch (error) {
    showError()
  }
}
